import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(): boolean {
    const today = new Date().getTime();
    const expira = Number(sessionStorage.getItem('expiresCF'));

    if ((expira < today) && this.router.url !== "/") {
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(['/login']).then(() => {
        window.location.reload();
      });
      return false;
    }

    if (this.auth.isAutenticated()) {
      return true;
    } else {
      this.router.navigateByUrl('/login');
      sessionStorage.clear();
      return false;
    }
  }
}
